var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dateTimeSelection flex-1 right-10"},[_c('ejs-datepicker',{attrs:{"format":"EEEE, MM/dd/yyyy","value":_vm.date},on:{"change":_vm.handleDateChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }